import types from "../types"

/* remove */
export default function involve(model, id) {
  return {
    type: types.involve,
    model,
    id,
  }
}
